module.exports = __webpack_public_path__ + "img/ls5.877b94ca.webp";